<template>
  <div>
    <page-header
      title="Offers"
      borderless
    />

    <div class="section">
      <div
        v-if="offers.areLoading"
        class="loader"
      />

      <div v-else-if="offers.allOffers.length === 0">
        <h2 class="title title--4">
          You don't have any offers.
        </h2>

        <p>
          Looks like you don't have any offers at this time. Check back soon!
        </p>
      </div>

      <div
        v-else
        class="container max-width-mobile"
      >
        <offer-summary-card
          v-for="offer in offers.allOffers"
          :key="offer.offerAllocationPublicId"
          :offer="offer"
        />
      </div>
    </div>
  </div>
</template>



<script>
  import errorHandlers from '@/services/error-handlers';
  import { mapGetters } from 'vuex';



  export default {
    name: 'OrderOffersPage',

    metaInfo() {
      return {
        title: 'Offers'
      };
    },

    computed: {
      ...mapGetters('merchant', ['loyaltyOptions']),
      ...mapGetters('offers', ['offers']),
      ...mapGetters('session', ['session'])
    },

    created() {
      this.onComponentCreated();
    },

    methods: {
      onComponentCreated() {
        if (this.loyaltyOptions.isVisible) {
          this.$router.replace({ name: 'loyalty', query: this.$route.query });
        }
        else {
          this.loadOffers();
        }
      },

      conditionallyOpenInStoreRedemptionModal() {
        const id = this.$route.query.redeemInStoreId;

        if (!id) {
          return;
        }

        const matchingOffer = this.offers.allOffers.find(offer => offer.offerAllocationPublicId === id);

        this.$openModal('offerInStoreRedemption', {
          offer: matchingOffer
        });
      },

      async loadOffers() {
        try {
          if (!this.session.initialPageLoad) {
            await this.$store.dispatch('offers/getOffers');
          }

          this.conditionallyOpenInStoreRedemptionModal();
        }

        catch (error) {
          errorHandlers.silent(error);
        }
      }
    }
  };
</script>
